export default __webpack_public_path__ + "static/hero_maid_tablet-6763ae82341c4ecdcd9fab1806b42e25.webp";